import _ from 'lodash';

const initialState = {
    stockRequestDataActive: [],
    stockRequestDataCompleted: [],
    stockRequestItemData: []
};

/**
 * 
 * @param {Object} state    Initial state of store 
 * @param {Object} action   action data
 * @returns {Object} newState 
 */
const reducerMoveStockCompany = (state = initialState, action) => {
    const newState = { ...state }
    var { data } = action;
    switch (action.type) {
        case 'FETCH_STOCK_REQUEST_COMPANY_DATA':
            var active = _.filter(data, (element) => {
                return element.stockrequestcompany?.approved === false;
            });

            var completed = _.filter(data, (element) => {
                return element.stockrequestcompany?.approved === true;
            });

            newState.stockRequestDataActive = active;
            newState.stockRequestDataCompleted = completed;
            break;

        case 'FETCH_STOCK_REQUEST_COMPANY_ITEM_DATA':
            // var { data } = action;
            newState.stockRequestItemData = data;
            break;

        default:
            break;
    }
    return newState;
}

export default reducerMoveStockCompany;
